import { fetchHil } from "../utils";

export default {
  namespaced: true,
  state: {
    all: [],
    global: [],
    globalCount: 0
  },
  mutations: {
    setGlobalNotifications(state, { notifications, total }) {
      state.global = notifications;
      state.globalCount = total;
    },

    setNotifications(state, notifications) {
      state.all = notifications;
    },

    setNotifsAsSeen(state, updatedNotifications) {
      state.all = state.all.map(n => {
        if (updatedNotifications.filter(nn => n._id === nn._id).length > 0) {
          return { ...n, seen: true };
        } else {
          return n;
        }
      });
      return state;
    }
  },
  actions: {
    async fetchGlobalNotifications({ commit }, { page, pageSize }) {
      const resp1 = await (
        await fetchHil(`/notifications?page=${page}&pageSize=${pageSize}`)
      ).json();
      commit("setGlobalNotifications", resp1);
    },

    async fetchNotifications({ commit }, { email }) {
      const resp1 = await (
        await fetchHil(`/notifications/for/${email}`)
      ).json();
      commit("setNotifications", resp1);
    },

    async markNotifsAsRead({ commit, state }, { projectId, estateId = null }) {
      const notifs = state.all.filter(
        notif => notif.idProject === projectId && estateId == notif.idEstate
      );
      for (let n of notifs) {
        await fetchHil(`/notifications/${n._id}/disable`);
      }
      if (notifs.length > 0) {
        commit("setNotifsAsSeen", notifs);
      }
    }
  }
};
